<template>
  <div class="edit-servicestatus">
    <mdb-card>
      <mdb-card-header class="pt-4 indigo">
        <mdb-card-title class="text-white"><strong>{{ $t("user_promo_code_banner") }}</strong></mdb-card-title>
      </mdb-card-header>
      <mdb-card-body v-if="this.loadReady === true">
        <mdb-row class="mt-5">
          <mdb-col md="12">
            <hr />
            <p class="h6 red-text bold">
              {{ $t("user_promo_code_banner_image") }}
            </p>
            <ImageInput
              :image-src="getImageSrc()"
              :imageWidth="400"
              :buttonName="$t('user_promo_code_banner_button_name')"
              v-on:general-image="userPromoCodeBannerImage"
            />
            <hr />
          </mdb-col>
          <mdb-col md="3">
            <mdb-input
              :label="$t('user_promo_code_banner_start_date')"
              type="date"
              v-model="userpromocodebanner.validfrom"
            />
          </mdb-col>
          <mdb-col md="3">
            <mdb-input
              :label="$t('user_promo_code_banner_end_date')"
              type="date"
              v-model="userpromocodebanner.validto"
            />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col md="12">
            <mdb-btn @click="saveUserPromoCodeBanner" color="indigo" class="white-text" icon="paper-plane">{{ $t("save") }}
            </mdb-btn>
          </mdb-col>
        </mdb-row>
      </mdb-card-body>
    </mdb-card>
  </div>
</template>

<script>
import ImageInput from "./ImageInput.vue";
import {
  mdbRow,
  mdbCol,
  mdbInput,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardTitle,
} from "mdbvue";

export default {
  name: "EditUserPromoCodeBanner",
  components: {
    mdbRow,
    mdbCol,
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardTitle,
    ImageInput,
  },
  props: {
  },
  methods: {
    getImageSrc() {
      if (this.userpromocodebanner.image === "")
          return "https://mdbootstrap.com/img/Photos/Others/placeholder.jpg";
        else return this.userpromocodebanner.image;
    },
    userPromoCodeBannerImage(image) {
      this.userpromocodebanner.image = image;
    },
    fillPage() {
      
    },
    loadUserPromoCodeBanner(id) {
      this.$notify.info({
        message: this.$t("loading_user_promo_code_banner"),
        position: "top right",
        timeOut: this.$store.state.notifytimeoutmedium,
      });
      this.$http
        .get(this.getuserpromocodebannerpath + id)
        .then((response) => {
          if (response.status == 200) {
            this.userpromocodebanner = response.data.userpromocodebanners[0];
            this.loadReady = true;
            setTimeout(() => this.fillPage(), 2000);
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          return error;
        });
    },
    saveUserPromoCodeBanner() {
      this.postData = {
        id: this.userpromocodebanner.id,
        unionmemberid: this.userpromocodebanner.unionmemberid,
        image: this.userpromocodebanner.image,
        url: "REFERRAL",
        validfrom: this.userpromocodebanner.validfrom,
        validto: this.userpromocodebanner.validto,
      };
       this.$http
        .post(this.saveuserpromocodebannerpath, JSON.stringify(this.postData))
        .then((response) => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("adding_user_promo_code_banner_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
          } else {
            this.$notify.error({
              message: this.$t("adding_user_promo_code_banner_not_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
          }
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("adding_user_promo_code_banner_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort,
          });
          console.log(error);
        })
        .finally(() => (this.loading = false));
    },
  },
  computed: {

  },
  mounted() {
    // check if id is provided in route params and load the user promo code banner
    if (this.$route.params.id) {
      this.loadUserPromoCodeBanner(this.$route.params.id);
    } else {
      this.userpromocodebanner = {
        id: 0,
        unionmemberid: null,
        image: "",
        url: "REFERRAL",
        validfrom: null,
        validto: null,
        active: 0,
      };
      this.loadReady = true;
    }
  },
  data() {
    return {
      saveuserpromocodebannerpath: "/1.0/front/userpromocodebanner",
      getuserpromocodebannerpath: "/1.0/front/userpromocodebanner/",
      userpromocodebanner: null,
      loadReady: false,
    };
  },
};
</script>

<style></style>
